import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Link, makeStyles } from '@material-ui/core';
import React from 'react';

import { fixLink } from '../../../../core/utils/link.utils';

const ExternalLinkCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  const classes = useStyles();

  if (value && Array.isArray(value) && value.length) {
    return (
      <>
        {value.map((v, i) => (
          <React.Fragment key={i}>
            <span>{i > 0 && ', '}</span>
            <Link className={classes.link} href={`${fixLink(v)}`} target="_blank">
              {v}
            </Link>
          </React.Fragment>
        ))}
      </>
    );
  }
  return (
    value && (
      <Link href={`${fixLink(value)}`} className={classes.link} target="_blank">
        {value}
      </Link>
    )
  );
};

const useStyles = makeStyles((theme) => ({
  link: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

export default ExternalLinkCellRenderer;
